shadow$provide[536] = function(require,module,exports) {
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var three_1 = require("three");
var mathbox_1 = require("mathbox");
var MathboxAPIContext_1 = __importDefault(require("./MathboxAPIContext"));
var util_1 = require("./util");
var ThreestrapContext_1 = __importDefault(require("../threestrap/ThreestrapContext"));
var Mathbox = function (props, ref) {
    var container = props.container, children = props.children, options = props.options, rootProps = __rest(props, ["container", "children", "options"]);
    var mathboxOptions = (0, util_1.useDeepCompareMemo)(options !== null && options !== void 0 ? options : {}, {});
    var _a = (0, react_1.useState)(null), selection = _a[0], setSelection = _a[1];
    (0, react_1.useEffect)(function () {
        if (!container)
            return function () { };
        var mathbox = (0, mathbox_1.mathBox)(__assign(__assign({}, mathboxOptions), { element: container }));
        setSelection(mathbox);
        /**
         * TODO: Should Mathbox component allow setting these more easily?
         */
        mathbox.three.renderer.setClearColor(new three_1.Color(0xffffff), 1.0);
        mathbox.three.camera.position.set(1, 1, 2);
        return function () {
            mathbox.select("*").remove();
            mathbox.three.destroy();
            setSelection(null);
        };
    }, [container, mathboxOptions]);
    (0, react_1.useEffect)(function () {
        if (!selection)
            return;
        selection.set(rootProps);
    }, [selection, rootProps]);
    (0, react_1.useImperativeHandle)(ref, function () { return selection; }, [selection]);
    return (selection && (react_1["default"].createElement(MathboxAPIContext_1["default"].Provider, { value: selection },
        react_1["default"].createElement(ThreestrapContext_1["default"].Provider, { value: selection.three }, children))));
};
exports["default"] = (0, react_1.forwardRef)(Mathbox);
//# sourceMappingURL=Mathbox.js.map
};